const ru = {
  meta: { title: "Trollfossjakten · Охота на троллей у водопадов — 84 тролля между Lavangen и Årstein" },
  sound: { mute: "Выключить звуки троллей", unmute: "Включить звуки троллей" },
  nav: { map: "Карта", trolls: "Тролли", seasons: "Сезоны", pricing: "Цены", faq: "Вопросы", getApp: "Скачать приложение", hosts: "Стать хозяином" },
  tagline: "61 тролль — бесплатно навсегда. Остальные прячутся — возьмите пропуск.",
  store: { soon: "Приложение почти выбралось из леса", soonBody: "Ссылки на магазины появятся к запуску — загляните совсем скоро.", appStore: "App Store", playStore: "Google Play", download: "Загрузите в", getIt: "Доступно в" },
  hero: {
    kicker: "Lavangen · Gratangen · Тромс, Норвегия",
    title: "Охота на 84 тролля между Lavangen и Årstein.",
    pitch: "9 водопадов, 84 нарисованных вручную тролля и одна дорога вдоль фьорда. Начать можно бесплатно — зимой на лыжах, летом на роликах.",
    cta: "Начать охоту",
    ctaMap: "Смотреть всю карту",
    stats: [["84", "тролля"], ["9", "водопадов"], ["61", "бесплатно навсегда"], ["4", "сезона"]],
    stamp: "Начать бесплатно",
    photoNote: "Водопады · фьорды · тролли",
  },
  what: {
    kicker: "Что такое Trollfossjakten?",
    title: "Сказочная охота за сокровищами вдоль настоящей дороги у фьорда.",
    cols: [
      { title: "Пройдите маршрут", body: "Идите по дороге от Lavangen до Årstein пешком, на велосипеде, лыжах или роликах. Путь отмечают девять водопадов." },
      { title: "Ловите троллей", body: "84 нарисованных вручную тролля прячутся у ручьёв, на берегу и в лавках. Найдите их, поймайте и заполните свой дневник." },
      { title: "Копите тролль-кроны", body: "Собирайте внутреннюю валюту приложения и тратьте её в домиках, кафе и магазинах-партнёрах вдоль маршрута." },
    ],
    callout: "Регистрация не нужна. Откройте приложение — и в путь.",
  },
  map: {
    kicker: "Карта маршрута",
    title: "Каждый тролль — на карте.",
    body: "84 тролля вдоль дороги от Lavangen до Årstein через Røkenes, Hestnes и Sørsida. Нажмите на метку, чтобы познакомиться, — а поймать тролля можно в приложении.",
    chips: { all: "Все", common: "Обычные", rare: "Редкие", epic: "Эпические", legendary: "Легендарные", festivals: "Праздники", merchants: "Торговцы" },
    showing: "троллей на карте",
    start: "Lavangen · старт",
    finish: "Årstein · финиш",
    waterfall: "Водопад",
    catchIt: "Поймать в приложении",
    close: "Закрыть",
    recenter: "К маршруту",
  },
  xp: {
    kicker: "Опыт и игровая система",
    title: "Охотьтесь, растите в уровне, немного хвастайтесь.",
    body: "Каждая поимка приносит опыт (XP). Чем реже тролль, тем больше награда, — а некоторые появляются только по календарю.",
    cards: {
      xp: { title: "XP по редкости", body: "Чем лучше прячутся, тем больше платят." },
      ach: { title: "12 достижений", body: "До 5 000 XP каждое. Для начала:", more: "+ ещё 6 ждут вас в приложении" },
      items: { title: "Предметы и наборы", body: "Собирайте вещицы, которые оставляют тролли, и составляйте наборы.", list: ["Жемчуг", "Руны", "Вафли", "Пиратское золото"] },
      kroner: { title: "Тролль-кроны", body: "Зарабатываются за приглашения друзей, ежедневное колесо и троллей-торговцев. Тратятся в домиках и магазинах-партнёрах." },
    },
    achievements: [["Первый улов", 20], ["Фанат праздников", 500], ["Король ручьёв", 800], ["Одинокий воин", 1000], ["Охотник за легендами", 1500], ["Круг сезонов", 5000]],
    extras: [
      { title: "Серии + щит серии", body: "Охотьтесь каждый день, чтобы растить серию. Щит спасает один пропущенный день в неделю." },
      { title: "Ежедневное колесо", body: "Колесо удачи с 3 уровнями призов. Одно вращение раз в 24 часа." },
      { title: "Пропуска", body: "Эпический или Редкий пропуск, действует 365 дней с активации. Варианты для одного человека, семьи, команды и автобусной группы." },
      { title: "Особые тролли", body: "2 тролля выходного дня (пт–вс), 10 праздничных троллей, 6 троллей-торговцев у местных предприятий и 5 промо-троллей." },
    ],
  },
  gallery: {
    kicker: "Дневник троллей",
    title: "Познакомьтесь со всеми 84.",
    body: "У каждого тролля есть имя, прозвище и своя причуда. Нажмите на карточку, чтобы прочитать запись в дневнике.",
    chips: { all: "Все", common: "Обычные", rare: "Редкие", epic: "Эпические", legendary: "Легендарные", festivals: "Праздники", merchants: "Торговцы", weekend: "Выходные", promo: "Промо" },
    more: "Показать ещё троллей",
    count: "из 84",
    portraitNote: "Остальные прячутся — найдите их в приложении.",
    hidden: "пока прячется",
    hiding: "Прячется",
  },
  journal: {
    entry: "Запись в дневнике",
    where: "Где",
    waterfall: "Водопад",
    xp: "XP",
    access: "Открывается",
    window: "Появляется",
    weekend: "Только с пятницы по воскресенье",
    liveNow: "Сейчас на тропе",
    catchIt: "Поймать в приложении",
  },
  access: { free: "Бесплатно навсегда", epic_pass: "Эпический пропуск", rare_pass: "Редкий пропуск" },
  rarity: { common: "Обычный", rare: "Редкий", epic: "Эпический", legendary: "Легендарный" },
  category: { stream: "Тролль ручья", intro: "Гид-проводник", merchant: "Тролль-торговец", promo: "Промо-тролль", weekend: "Тролль выходного дня", festival_sami: "Тролль саамского праздника", festival_norwegian: "Тролль норвежского праздника" },
  specials: {
    kicker: "Особые тролли",
    title: "19 особых троллей — и ещё 5 промо-троллей.",
    body: "У некоторых троллей свой календарь. Праздничные тролли появляются только в настоящие даты праздников.",
    flavours: [
      { key: "intro", count: 1, title: "Гид-проводник", body: "Ваш первый тролль в Lavangen — покажет, как устроена охота." },
      { key: "festival_sami", count: 4, title: "Тролли саамских праздников", body: "День саамов, Riddu Riđđu и Márkomeannu." },
      { key: "festival_norwegian", count: 6, title: "Тролли норвежских праздников", body: "От 17 мая до полярной ночи." },
      { key: "weekend", count: 2, title: "Тролли выходного дня", body: "Выходят только с пятницы по воскресенье." },
      { key: "merchant", count: 6, title: "Тролли-торговцы", body: "Живут у настоящих местных предприятий на маршруте." },
      { key: "promo", count: 5, title: "Промо-тролли", body: "Открываются за приглашения, плакаты и промокоды." },
    ],
    calendar: "Календарь праздников",
    next: "Ближайший период",
    liveNow: "Сейчас на тропе",
  },
  festivals: {
    "Sámi National Day": "День саамов", "Riddu Riđđu": "Фестиваль Riddu Riđđu", "Márkomeannu": "Фестиваль Márkomeannu",
    "Constitution Day": "День Конституции Норвегии", "Midsummer": "Иванов день", "Lussinatta": "Ночь Люсии",
    "Christmas": "Рождество", "Midnight Sun": "Полуночное солнце", "Polar Night": "Полярная ночь",
  },
  seasons: {
    kicker: "Четыре сезона",
    title: "Один маршрут — четыре совершенно разных настроения.",
    standout: "Тролль сезона",
    tabs: {
      winter: { name: "Зима", title: "Лыжи под северным сиянием", body: "Скользите по маршруту на беговых лыжах, пока над фьордом танцует северное сияние. Налобный фонарь — на голову, термос — полный." },
      spring: { name: "Весна", title: "Оленья Пасха", body: "Долгие светлые дни, хрустящий наст и кочующие олени. Идеально для семей на спокойных участках." },
      summer: { name: "Лето", title: "Костры под полуночным солнцем", body: "Катайтесь на роликах по ровным участкам, пусть дети мчатся вперёд на велосипедах, а когда солнце не захочет садиться — разведите костёр." },
      autumn: { name: "Осень", title: "Грибные походы", body: "Золотые берёзы, черника и лисички. Бабушкам и дедушкам нравятся спокойные участки — троллям тоже." },
    },
  },
  merchants: {
    kicker: "Местный бизнес",
    title: "Тролли-торговцы живут в настоящих местных заведениях.",
    body: "Шесть троллей живут в домиках, кафе, магазинах и пунктах проката вдоль маршрута. Ловите их бесплатно и тратьте там свои тролль-кроны.",
    partnerSoon: "Партнёр будет объявлен к запуску",
    spend: "Здесь принимают тролль-кроны",
    types: { "Cabin rental": "Аренда домиков", "Farm shop": "Фермерская лавка", "Café": "Кафе", "Kayak rental": "Прокат каяков", "Bakery": "Пекарня", "Grocer · finish line": "Продукты · финиш" },
  },
  pricing: {
    kicker: "Цены",
    title: "Начните бесплатно. За остальными — с пропуском.",
    launch: "Стартовая цена · скидка 50 % на весь сезон 2026",
    tiers: { person: "Один человек", family: "Семья", team: "Команда", bus: "Автобусная группа" },
    days: "365 дней с момента активации",
    free: { name: "Бесплатно", price: "0 kr", line: "61 тролль — бесплатно навсегда", body: "Регистрация не нужна.", perks: ["Все обычные и редкие тролли ручьёв", "Все 6 троллей-торговцев", "Гид-проводник + 5 промо-троллей"], cta: "Начать бесплатно" },
    epic: { name: "Эпический пропуск", line: "Открывает эпических и легендарных троллей", perks: ["Все эпические и легендарные тролли ручьёв", "Оба тролля выходного дня"], cta: "Получить Эпический пропуск" },
    rare: { name: "Редкий пропуск", line: "Открывает всех троллей — включая праздничных и легендарных", perks: ["Все 84 тролля", "Все 10 праздничных троллей", "Всё из Эпического пропуска"], cta: "Получить Редкий пропуск", ribbon: "Все 84 тролля" },
    note: "Пропуска покупаются в приложении, цены в норвежских кронах (kr). Стартовая цена действует ограниченное время.",
    was: "было",
  },
  faq: {
    kicker: "Вопросы и ответы",
    title: "Вопросы со стартовой линии.",
    items: [
      ["Нужно ли регистрироваться?", "Нет. Скачайте приложение, откройте его и начинайте охоту. 61 тролль — бесплатно навсегда."],
      ["Есть ли мобильная связь на маршруте?", "Вдоль дороги связь обычно хорошая, но в долинах местами может пропадать. Зарядите телефон и запишите номера экстренных служб перед выходом."],
      ["Можно ли играть зимой?", "Да. Тролли на месте круглый год. Возьмите лыжи или ледоходы, налобный фонарь для полярной ночи и проверьте состояние дорог перед выходом."],
      ["Подходит ли это детям?", "Да. Многие тролли стоят рядом с дорогой, а спокойные участки подходят для маленьких ног, велосипедов и колясок. Часть маршрута идёт по дорогам общего пользования — следите за движением."],
      ["Где припарковаться и как вернуться?", "Начинайте в Lavangen или Årstein. На части маршрута ходят региональные автобусы — проверьте местное расписание заранее."],
      ["Кто такой тролль-торговец?", "Тролль, который живёт у настоящего местного предприятия на маршруте — в домике, кафе или магазине. Поймать его можно бесплатно, а ещё там можно потратить тролль-кроны."],
      ["Что такое тролль-кроны?", "Внутренняя валюта приложения. Зарабатывайте её за приглашения друзей, ежедневное колесо и троллей-торговцев и тратьте в домиках и магазинах-партнёрах."],
      ["Насколько точны даты праздников?", "Праздничные тролли появляются только в настоящие даты праздников. Если праздник переносится, тролль переносится вместе с ним."],
      ["Сколько действует пропуск?", "Эпический и Редкий пропуска действуют 365 дней с момента активации, есть варианты для одного человека, семьи, команды и автобусной группы."],
      ["А как же моя приватность?", "Играть можно без аккаунта. Приложение использует ваше местоположение только во время игры, чтобы показывать троллей рядом. Этот сайт ничего не собирает."],
    ],
  },
  install: { title: "Trollfossjakten", body: "61 тролль бесплатно", cta: "Скачать", dismiss: "Скрыть панель загрузки" },
  footer: { supporter: "Стать партнёром", about: "О проекте", press: "Пресса", privacy: "Конфиденциальность", terms: "Условия", contact: "Контакты", follow: "Следите за охотой", soon: "Появится к запуску", country: "Норвегия", supportedBy: "При поддержке" },
  logoAlt: "Логотип Trollfossjakten",
  langSwitch: "Язык",
  a11y: { menu: "Меню", footer: "Подвал сайта", zoomIn: "Приблизить", zoomOut: "Отдалить", notifications: "Уведомления" },
  sos: "Экстренная помощь",
  emergency: {
    back: "Назад",
    title: "Экстренная помощь",
    alert: "Если вы в опасности, немедленно звоните в местную экстренную службу.",
    h1: "SOS — быстрая помощь в любой точке маршрута.",
    intro: "Нажмите на номер, чтобы позвонить. Отправьте своё местоположение — с фото и сообщением, если нужно, — семье, друзьям или спасателям.",
    step: "Шаг {n}",
    country: "Ваша страна",
    search: "Найти страну…",
    noMatch: "Нет стран по запросу",
    callNow: "Позвонить —",
    all: "Все экстренные службы",
    police: "Полиция",
    fire: "Пожарные",
    ambulance: "Скорая помощь",
    locTitle: "Отправьте своё местоположение",
    detect: "Определить моё местоположение",
    locating: "Определяем…",
    refresh: "Обновить местоположение",
    noGeo: "Ваш браузер не поддерживает геолокацию.",
    locFail: "Не удалось определить местоположение.",
    near: "Рядом с",
    openMaps: "Открыть в Google Картах ↗",
    msgLabel: "Добавьте сообщение (необязательно)",
    msgPh: "Например: подвернул ногу у второго водопада. Возьмите воду и аптечку.",
    photoLabel: "Прикрепите фото (необязательно)",
    choose: "Выбрать фото",
    change: "Заменить фото",
    remove: "Удалить",
    previewAlt: "Прикреплённое фото",
    send: "Отправить экстренное местоположение",
    copy: "Копировать",
    shared: "Отправлено с вашего устройства.",
    shareFail: "Не удалось открыть меню отправки. Попробуйте «Копировать».",
    copied: "Скопировано.",
    copyFail: "Не удалось скопировать.",
    privacy: "Отправка идёт через встроенное меню телефона (SMS, WhatsApp, почта и т. д.). Через наши серверы ничего не передаётся. В настоящей чрезвычайной ситуации обязательно позвоните и по номеру выше.",
    backTrail: "Вернуться к маршруту",
    msgHead: "🆘 ЧРЕЗВЫЧАЙНАЯ СИТУАЦИЯ — мне нужна помощь.",
    mapLabel: "Карта",
    timeLabel: "Время",
    shareTitle: "Экстренная помощь — Trollfossjakten",
    notes: {
      NO: "112 — общеевропейский номер экстренных служб. 110 — напрямую пожарные, 113 — скорая помощь.",
      SE: "Единый номер 112 для всех служб.",
      FI: "112 соединяет с полицией, пожарными и скорой.",
      DK: "112 — экстренные случаи, 114 — полиция в несрочных случаях.",
      IS: "Единый номер по всей стране: 112.",
      DE: "110 — полиция, 112 — пожарные и скорая.",
      FR: "17 — полиция, 18 — пожарные, 15 — скорая (SAMU). 112 тоже работает.",
      GB: "999 (или 112) — все экстренные службы. 101 — полиция в несрочных случаях.",
      IE: "Работают и 112, и 999.",
      NL: "112 — экстренные случаи, 0900-8844 — полиция в несрочных случаях.",
      ES: "112 — все службы. Национальная полиция 091, местная полиция 092.",
      IT: "112 — все экстренные случаи, 113 — государственная полиция.",
      PL: "112 соединяет со всеми службами.",
      US: "911 — любые экстренные случаи. Во многих городах 311 — для несрочных вопросов.",
      CA: "911 по всей стране для всех экстренных случаев.",
      AU: "Тройной ноль (000). С мобильного работает и 112.",
      NZ: "111 по всей стране. 105 — полиция в несрочных случаях.",
      CN: "110 — полиция, 119 — пожарные, 120 — скорая, 122 — ДТП.",
      RU: "112 — все службы. 102 — полиция, 101 — пожарные, 103 — скорая.",
      TH: "191 — полиция, 199 — пожарные, 1669 — скорая. Туристическая полиция — 1155 (говорят по-английски).",
    },
  },
};

export default ru;
